export default class ResourcesPanel {
    constructor() {
        $(document).ready(() => {
            this.tabbed = document.querySelector('.accordion-to-tab');
            this.tablist = this.tabbed.querySelector('.accordion-toc');
            this.tabs = this.tabbed.querySelectorAll('.accordion-trigger');
            this.panels = this.tabbed.querySelectorAll('.content-area');

            // If there are no tabs added in the CMS, don't do anything else
            if (this.tabs.length > 0) {
                this.initListeners();
            }
        });
    }

    initListeners() {
        // Add tablist role to the first .accordion-toc in the tabbed container
        this.tablist.setAttribute('role', 'tablist');

        Array.prototype.forEach.call(this.tabs, (tab, i) => {
            // Add semantics are remove user focusability for each tab
            tab.setAttribute('role', 'tab');
            tab.setAttribute('id', `tab${i + 1}`);
            tab.setAttribute('tabindex', '-1');
            tab.parentNode.setAttribute('role', 'presentation');

            const handleClick = (e) => {
                // Don't allow click to follow link for mobile view
                if (window.innerWidth < 1025) e.preventDefault();

                const currentTab = this.tablist.querySelector('[aria-selected]');
                if (e.currentTarget === currentTab) {
                    this.toggleTab(e.currentTarget);
                } else {
                    this.switchTab(currentTab, e.currentTarget);
                }
            };

            const handleHover = (e) => {
                const currentTab = this.tablist.querySelector('[aria-selected]');

                if (e.currentTarget !== currentTab && window.innerWidth > 1024) {
                    this.switchTab(currentTab, e.currentTarget);
                }
            };

            tab.addEventListener('click', handleClick);
            tab.addEventListener('mouseenter', handleHover);

            // Handle keydown events for keyboard users
            tab.addEventListener('keydown', (e) => {
                // Get the index of the current tab in the this.tabs node list
                const index = Array.prototype.indexOf.call(this.tabs, e.currentTarget);

                // Work out which key the user is pressing and
                // Calculate the new tab's index where appropriate
                let direction;
                switch (e.which) {
                    case 38:
                        // up
                        direction = index - 1;
                        break;
                    case 40:
                        // down
                        direction = index + 1;
                        break;
                    case 39:
                        // right
                        direction = 'content';
                        break;
                    default:
                        direction = null;
                        break;
                }

                if (direction !== null) {
                    e.preventDefault();

                    // If the down key is pressed, move focus to the open panel,
                    // otherwise switch to the adjacent tab
                    if (direction === 'content') {
                        this.panels[i].focus();
                    } else if (this.tabs[direction]) {
                        this.switchTab(e.currentTarget, this.tabs[direction]);
                    }
                }
            });
        });

        // Add tab panel semantics and hide them all
        Array.prototype.forEach.call(this.panels, (panel, i) => {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('tabindex', '0');
            panel.setAttribute('aria-labelledby', this.tabs[i].id);
            panel.hidden = true;

            panel.addEventListener('keydown', (e) => {
                if (e.which === 37) {
                    // If left is pressed from a panel, go back to current tab
                    document.querySelector('.accordion-header.active a').focus();
                }
            });
        });

        // Initially activate the first tab and reveal the first tab panel
        this.tabs[0].removeAttribute('tabindex');
        this.tabs[0].setAttribute('aria-selected', 'true');
        this.panels[0].hidden = false;
    }

    // The tab switching function
    switchTab(oldTab, newTab) {
        // Switch classes of list items
        if (oldTab) {
            oldTab.parentNode.classList.remove('active');
            oldTab.removeAttribute('aria-selected');
            oldTab.setAttribute('tabindex', '-1');

            const oldIndex = Array.prototype.indexOf.call(this.tabs, oldTab);
            this.panels[oldIndex].hidden = true;
        }
        newTab.parentNode.classList.add('active');
        newTab.focus();
        newTab.removeAttribute('tabindex');
        newTab.setAttribute('aria-selected', 'true');
        const index = Array.prototype.indexOf.call(this.tabs, newTab);
        this.panels[index].hidden = false;

        // Force lazy loaded images
        $(this.panels[index]).find('.lazy').Lazy({ effect: 'fadeIn', effectTime: 200 });
    }

    toggleTab(tab) {
        const header = tab.parentNode;
        const isActive = header.classList.contains('active');
        const content = tab.parentNode.querySelector('.content-area');

        // Toggle state, similar to switchTab()
        if (isActive) {
            header.classList.remove('active');
            tab.removeAttribute('aria-selected');
            content.hidden = true;
        } else {
            header.classList.add('active');
            tab.setAttribute('aria-selected', 'true');
            content.hidden = false;
        }
    }
}
